<div class="packages-page">
  <div class="page-header">
    <h2 class="page-title">Paketler</h2>
    <lib-button variant="primary" (buttonClick)="openAdd()">
      <span class="btn-content">
        <svg lucidePlus [size]="16" [strokeWidth]="2.25" aria-hidden="true"></svg>
        <span>Ekle</span>
      </span>
    </lib-button>
  </div>

  <div class="search-bar">
    <input
      class="search-input"
      type="text"
      placeholder="İsme göre ara..."
      [(ngModel)]="searchTerm"
      (keyup.enter)="onSearch()"
    />
    <lib-button variant="outline" size="sm" (buttonClick)="onSearch()">
      <span class="btn-content">
        <svg lucideSearch [size]="15" [strokeWidth]="2" aria-hidden="true"></svg>
        <span>Ara</span>
      </span>
    </lib-button>
    @if (searchTerm) {
      <lib-button variant="text" size="sm" (buttonClick)="clearSearch()">Temizle</lib-button>
    }
  </div>

  @if (loading()) {
    <div class="loading-overlay">
      <div class="spinner"></div>
      <p>Yükleniyor...</p>
    </div>
  } @else {
    <div class="table-wrapper">
      <table class="data-table">
        <thead>
          <tr>
            <th class="action-col">
              <div class="row-actions">
                <lib-button variant="text" size="sm" class="portal-icon-btn" (buttonClick)="load()" title="Yenile">
                  <svg lucideRefreshCw [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                </lib-button>
              </div>
            </th>
            <th>Açıklama</th>
            <th>Aylık Fiyat</th>
            <th>Yıllık Fiyat</th>
            <th>Aylık İndirim</th>
            <th>Yıllık İndirim</th>
            <th>Aylık Toplam</th>
            <th>Yıllık Toplam</th>
            <th>Aktif</th>
          </tr>
        </thead>
        <tbody>
          @if (items().length === 0) {
            <tr><td colspan="9" class="empty-row">Kayıt bulunamadı</td></tr>
          }
          @for (item of items(); track item.id) {
            <tr>
              <td class="action-col">
                <div class="row-actions">
                  <lib-button variant="text" size="sm" class="portal-icon-btn" (buttonClick)="openEdit(item)" title="Düzenle">
                    <svg lucidePencil [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                  </lib-button>
                  <lib-button variant="text" size="sm" class="portal-icon-btn" (buttonClick)="openFeaturesDialog(item)" title="Paket İçerikleri">
                    <svg lucideList [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                  </lib-button>
                  <lib-button
                    variant="text"
                    size="sm"
                    class="portal-icon-btn portal-icon-btn--danger"
                    (buttonClick)="delete(item)"
                    title="Sil"
                  >
                    <svg lucideTrash2 [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                  </lib-button>
                </div>
              </td>
              <td>{{ item.name }}</td>
              <td>{{ formatPrice(item.monthlyPrice, item.currencyType) }}</td>
              <td>{{ formatPrice(item.yearlyPrice, item.currencyType) }}</td>
              <td>{{ item.monthlyDiscount ? item.monthlyDiscount + '%' : '-' }}</td>
              <td>{{ item.yearlyDiscount ? item.yearlyDiscount + '%' : '-' }}</td>
              <td>{{ formatPrice(item.totalMonthlyPrice, item.currencyType) }}</td>
              <td>{{ formatPrice(item.totalYearlyPrice, item.currencyType) }}</td>
              <td>
                <span class="badge" [class.badge-yes]="item.isActive" [class.badge-no]="!item.isActive">
                  {{ item.isActive ? 'Aktif' : 'Pasif' }}
                </span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <lib-button variant="text" size="sm" class="portal-icon-btn" [disabled]="page() === 0" (buttonClick)="prevPage()" title="Önceki">
        <svg lucideChevronLeft [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </lib-button>
      <span class="page-info">Sayfa {{ page() + 1 }} / {{ totalPages() || 1 }}</span>
      <lib-button variant="text" size="sm" class="portal-icon-btn" [disabled]="page() >= totalPages() - 1" (buttonClick)="nextPage()" title="Sonraki">
        <svg lucideChevronRight [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </lib-button>
    </div>
  }
</div>

<!-- Ekle/Düzenle Dialog -->
@if (showFormDialog()) {
  <div class="dialog-backdrop" (click)="closeFormDialog()"></div>
  <div class="dialog">
    <div class="dialog-header">
      <h3>{{ isEdit() ? 'Paketi Düzenle' : 'Yeni Paket' }}</h3>
      <button class="dialog-close" (click)="closeFormDialog()">
        <svg lucideX [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </button>
    </div>
    <div class="dialog-body">
      <div class="form-row">
        <div class="form-field">
          <label class="field-label">Açıklama *</label>
          <input
            class="form-input"
            type="text"
            [ngModel]="formModel().name"
            (ngModelChange)="updateField('name', $event)"
            placeholder="Paket adı"
          />
        </div>
        <div class="form-field">
          <label class="field-label">Para Birimi</label>
          <select class="form-select" [ngModel]="formModel().currencyType" (ngModelChange)="updateField('currencyType', $event)">
            <option value="USD">USD</option>
            <option value="EUR">EUR</option>
            <option value="TRY">TRY</option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          <label class="field-label">Aylık Fiyat</label>
          <input
            class="form-input"
            type="number"
            min="0"
            [ngModel]="formModel().monthlyPrice"
            (ngModelChange)="updateField('monthlyPrice', +$event)"
            placeholder="0.00"
          />
        </div>
        <div class="form-field">
          <label class="field-label">Yıllık Fiyat</label>
          <input
            class="form-input"
            type="number"
            min="0"
            [ngModel]="formModel().yearlyPrice"
            (ngModelChange)="updateField('yearlyPrice', +$event)"
            placeholder="0.00"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          <label class="field-label">Aylık İndirim (%)</label>
          <input
            class="form-input"
            type="number"
            min="0"
            max="100"
            [ngModel]="formModel().monthlyDiscount"
            (ngModelChange)="updateField('monthlyDiscount', +$event)"
            placeholder="0"
          />
        </div>
        <div class="form-field">
          <label class="field-label">Yıllık İndirim (%)</label>
          <input
            class="form-input"
            type="number"
            min="0"
            max="100"
            [ngModel]="formModel().yearlyDiscount"
            (ngModelChange)="updateField('yearlyDiscount', +$event)"
            placeholder="0"
          />
        </div>
      </div>
      <div class="totals-row">
        <span>Aylık Toplam: <strong>{{ formatPrice(formModel().totalMonthlyPrice, formModel().currencyType) }}</strong></span>
        <span>Yıllık Toplam: <strong>{{ formatPrice(formModel().totalYearlyPrice, formModel().currencyType) }}</strong></span>
      </div>
      <div class="form-field checkbox-field">
        <input
          type="checkbox"
          id="isActive"
          [ngModel]="formModel().isActive"
          (ngModelChange)="updateField('isActive', $event)"
        />
        <label for="isActive">Aktif</label>
      </div>
    </div>
    <div class="dialog-footer">
      <lib-button variant="outline" (buttonClick)="closeFormDialog()">İptal</lib-button>
      <lib-button variant="primary" [disabled]="formSaving()" (buttonClick)="save()">
        {{ formSaving() ? 'Kaydediliyor...' : 'Kaydet' }}
      </lib-button>
    </div>
  </div>
}

<!-- Paket İçerikleri Dialog -->
@if (showFeaturesDialog()) {
  <div class="dialog-backdrop" (click)="closeFeaturesDialog()"></div>
  <div class="dialog dialog-wide">
    <div class="dialog-header">
      <h3>{{ selectedPackage()?.name }} — İçerikler</h3>
      <button class="dialog-close" (click)="closeFeaturesDialog()">
        <svg lucideX [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </button>
    </div>
    <div class="dialog-body">
      <div class="inner-actions">
        <lib-button variant="primary" size="sm" (buttonClick)="openAddFeatureDialog()">
          <span class="btn-content">
            <svg lucidePlus [size]="16" [strokeWidth]="2.25" aria-hidden="true"></svg>
            <span>Özellik Ekle</span>
          </span>
        </lib-button>
        <div class="row-actions">
          <lib-button variant="text" size="sm" (buttonClick)="loadPackageFeatures()">
            <svg lucideRefreshCw [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
          </lib-button>
        </div>
      </div>
      @if (featuresLoading()) {
        <div class="loading-overlay"><div class="spinner"></div><p>Yükleniyor...</p></div>
      } @else {
        <table class="data-table">
          <thead>
            <tr>
              <th class="action-col"></th>
              <th>Özellik Adı</th>
            </tr>
          </thead>
          <tbody>
            @if (packageFeatures().length === 0) {
              <tr><td colspan="2" class="empty-row">Bu pakete henüz özellik eklenmemiş</td></tr>
            }
            @for (pf of packageFeatures(); track pf.id) {
              <tr>
                <td class="action-col">
                  <div class="row-actions">
                    <lib-button variant="text" size="sm" class="portal-icon-btn portal-icon-btn--danger" (buttonClick)="deletePackageFeature(pf)" title="Kaldır">
                      <svg lucideTrash2 [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
                    </lib-button>
                  </div>
                </td>
                <td>{{ pf.featureName }}</td>
              </tr>
            }
          </tbody>
        </table>
        <div class="pagination">
          <lib-button variant="text" size="sm" [disabled]="featuresPage() === 0" (buttonClick)="prevFeaturesPage()">
            <svg lucideChevronLeft [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
          </lib-button>
          <span class="page-info">Sayfa {{ featuresPage() + 1 }}</span>
          <lib-button variant="text" size="sm" [disabled]="featuresPage() >= featuresTotalPages() - 1" (buttonClick)="nextFeaturesPage()">
            <svg lucideChevronRight [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
          </lib-button>
        </div>
      }
    </div>
  </div>
}

<!-- Özellik Ekle Dialog -->
@if (showAddFeatureDialog()) {
  <div class="dialog-backdrop dialog-backdrop-top" (click)="closeAddFeatureDialog()"></div>
  <div class="dialog dialog-sm dialog-top">
    <div class="dialog-header">
      <h3>Özellik Ekle</h3>
      <button class="dialog-close" (click)="closeAddFeatureDialog()">
        <svg lucideX [size]="16" [strokeWidth]="2" aria-hidden="true"></svg>
      </button>
    </div>
    <div class="dialog-body">
      @if (allFeaturesLoading()) {
        <p>Özellikler yükleniyor...</p>
      } @else {
        <div class="form-field">
          <label class="field-label">Özellik Seçiniz</label>
          <select
            class="form-select"
            [ngModel]="selectedFeatureId()"
            (ngModelChange)="selectedFeatureId.set($event)"
          >
            <option value="">-- Seçiniz --</option>
            @for (f of availableFeatures(); track f.id) {
              <option [value]="f.id">{{ f.name }}</option>
            }
          </select>
        </div>
      }
    </div>
    <div class="dialog-footer">
      <lib-button variant="outline" (buttonClick)="closeAddFeatureDialog()">İptal</lib-button>
      <lib-button variant="primary" [disabled]="!selectedFeatureId()" (buttonClick)="savePackageFeature()">Ekle</lib-button>
    </div>
  </div>
}
